import { ThemeSize } from "@/types/styles/ThemeSize"
import { createContext, Dispatch, SetStateAction } from "react"

export const ChosenThemeSizeContext = createContext<ThemeSize | undefined>(undefined);

export default ChosenThemeSizeContext;